<app-page-container>
  <div class="opcoes">
    <div class="titulo">
      <span>Equipamentos</span>
    </div>

    <div class="botoes__acoes">
      <div class="sub-titulo">
        <p>Selecione o tipo dos equipamentos que deseja visualizar:</p>
      </div>
      <div class="tab-navegacao">
        <button
          class="botao__acao"
          (click)="estaAtivoOuInativo()"
          [ngClass]="{
            'is-secondary': equipamentoAtivo,
            'is-disabled': !equipamentoAtivo
          }"
          [disabled]="equipamentoAtivo"
        >
          Ativos
        </button>
        <button
          class="botao__acao"
          (click)="estaAtivoOuInativo()"
          [ngClass]="{
            'is-secondary': !equipamentoAtivo,
            'is-disabled': equipamentoAtivo
          }"
          [disabled]="!equipamentoAtivo"
        >
          Inativos
        </button>
      </div>
    </div>

    <form [formGroup]="filtraForm">
      <app-input-pesquisar
        formControlName="pesquisar"
        (buscar)="getEquipamentos(true)"
      >
        <app-filtro-generico
          class="ms-3"
          [showOptions]="true"
          (OnClickApplyButton)="getEquipamentos(true)"
          (filterData)="receiveFilterData($event)"
          [selectInputs]="[
            {
              label: 'Site',
              formControlName: 'site',
              options: sitesOptions,
              exibir: exibirSite,
              valor: valorSite
            }
          ]"
          [filterInputs]="[
            { label: 'Número de Série', formControlName: 'numserie' },
            { label: 'Patrimônio', formControlName: 'patrimonio' },
            { label: 'Contrato', formControlName: 'contrato' },
            { label: 'Departamento', formControlName: 'departamento' }
          ]"
        >
          <div class="filter">
            <label class="filter__label">
              Contrato Ativo
              <input
                formControlName="contratoAtivo"
                class="filter__select-input"
                type="checkbox"
              />
            </label>
          </div>
        </app-filtro-generico>
      </app-input-pesquisar>
    </form>

    <div>
      <app-botoes-files
        (OnClickApplyPDFButton)="getDownloadPDFEquipamentos()"
        (OnClickApplyCSVButton)="getDownloadCSVEquipamentos()"
        [disableXLSX]="true"
      ></app-botoes-files>
    </div>

    <app-tabela
      [cabecalhos]="cabecalhosTabela"
      [items]="equipamentos.registros"
      [colunasOcultas]="['Suporte', 'Ações']"
      [condicoesColunas]="[
        { columnName: 'Suporte', condition: true },
        { columnName: 'Ações', condition: true },
        { columnName: 'QR Code', condition: podeGerenciarQRCode }
      ]"
    >
      <tr *ngFor="let equipamento of equipamentos.registros">
        <td>
          {{
            equipamento.nomeFantasiaCliente ||
              equipamento.nomeCliente ||
              'Sem dados'
          }}
        </td>
        <td>{{ equipamento.nomeSite }}</td>
        <td>{{ equipamento.local ?? 'Sem dados' }}</td>
        <td>{{ equipamento.numPat || 'Sem dados' }}</td>
        <td>{{ equipamento.codigoContr }}</td>
        <td>{{ equipamento.equipamentoAtivo ? 'Ativo' : 'Inativo' }}</td>
        <td>{{ equipamento.nomeMarcaProduto }}</td>
        <td>{{ equipamento.modelo }}</td>
        <td>{{ equipamento.numSerie }}</td>
        <td>
          <div class="bloco__editar">
            <ng-container *ngIf="equipamento.emAberto">
              <button
                style="color: var(--suporte-cta); margin-left: 10px"
                [routerLink]="[
                  '/historico-de-chamados',
                  equipamento.numSerie,
                  equipamento.codigoContr
                ]"
              >
                Visualizar chamado
              </button>
            </ng-container>
          </div>
        </td>
        <td>
          <div class="detalhes-editar">
            <button
              [routerLink]="[
                'detalhes',
                equipamento.numSerie,
                equipamento.codigoContr
              ]"
              class="detalhes__style"
            >
              Detalhes
            </button>
          </div>
        </td>
        <td *ngIf="podeGerenciarQRCode">
          <button
            (click)="gerarQRCode(equipamento.netName)"
            [disabled]="isGerandoQRCode === equipamento.netName"
            class="qr-code-btn"
            [title]="
              isGerandoQRCode === equipamento.netName
                ? 'Gerando QR Code...'
                : 'Gerar QR Code'
            "
          >
            <ng-container
              *ngIf="
                isGerandoQRCode === equipamento.netName;
                else qrIconTemplate
              "
            >
              <span class="spinner"></span>
              <span class="qr-text">Gerando</span>
            </ng-container>
            <ng-template #qrIconTemplate>
              <i class="qr-icon">📱</i>
              <span class="qr-text">QR Code</span>
            </ng-template>
          </button>
        </td>
      </tr>
    </app-tabela>
  </div>

  <app-paginacao
    nomeDaLista="Equipamentos"
    [(dados)]="equipamentos"
    (dadosChange)="getEquipamentos()"
    *ngIf="equipamentos.registros.length !== 0"
  ></app-paginacao>
</app-page-container>

<iframe
  #printFrame
  style="display: none; position: absolute; top: -10000px; left: -10000px"
></iframe>

<div
  *ngIf="qrCodeModalVisible"
  class="qr-code-modal-overlay"
  (click)="fecharModal()"
>
  <div class="qr-code-modal" (click)="$event.stopPropagation()">
    <div class="modal-header no-print">
      <h3>QR Code Gerado</h3>
      <button (click)="fecharModal()" class="close-btn">×</button>
    </div>

    <div class="modal-body">
      <div class="qr-template-container print-area">
        <div class="qr-template">
          <div class="qr-info">
            <img
              src="assets/images/kmDoBrasil/logo/logoQrCode.png"
              class="qr-logo"
            />
            <p class="qr-site">www.kmdobrasil.com.br</p>
            <div class="serial-wrapper">
              <p class="qr-label">Nº. de Série:</p>
<p [ngClass]="getClasseTamanhoSerial(equipamentoSelecionado?.numSerie)">
  {{ equipamentoSelecionado?.numSerie }}
</p>            </div>
          </div>

          <div class="qr-code-area">
            <img [src]="qrCodeModalImage" class="qr-code-img" />
            <p class="qr-scan-text">Escaneie para Suporte</p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer no-print">
      <button (click)="copiarParaClipboard()" class="btn">Copiar URL</button>
      <button (click)="imprimirQRCode()" class="btn">Imprimir</button>
      <button (click)="fecharModal()" class="btn">Fechar</button>
    </div>
  </div>
</div>
